export default {
  title: 'Demander la suppression des données pour {{name}}',
  description:
    "Cela crée une demande de suppression de données RGPD. Un administrateur doit l'approuver avant la suppression définitive des données du client.",
  form: {
    note: {
      label: 'Remarque',
      placeholder: 'Ajouter un contexte à cette demande (facultatif)',
    },
  },
  buttons: {
    confirm: 'Demander la suppression',
  },
  toasts: {
    success: 'Demande de suppression de données créée',
    error: 'Échec de la création de la demande de suppression',
  },
};
